// extracted by mini-css-extract-plugin
export default {"CardDeckContainer":"CardDeck_CardDeckContainer__1jq3Q","Card":"CardDeck_Card__pbOr7"};